import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Button, Modal } from "react-bootstrap";
import PayoutRouting from "./PayoutRouting"; // Assuming this component exists
import swal from "sweetalert";
import RouteIcon from "@mui/icons-material/Route";
import {
  ENABLE_DISABLE_PAYOUT_ROUTING,
  UPDATE_MERCHANT,
  GET_PREV_MAPPED_DETAILS_PAYOUT,
  GET_ALL_PAYOUT_ROUTING_VIEW,
  ENABLE_DISABLE_VIRTUAL_ACC,
  UPDATE_MERCHANT_ALl,
} from "../../utils/constant"; // Ensure all constants are correctly imported
import useApiServices from "../../utils/useApiServices"; // Assuming this hook exists
import { GET_VIRTUAL_ACCOUNT_DATA } from "../../utils/constant";

// Assuming these are available or can be removed if not used
import CustomTip from "../../common/CustomToolTip/CustomTip"; // Assuming this component exists
import { ToolsActionRegistry } from "../../Privillages/ActionRegistry";
import useHasPrivilege from "../../Privillages/useHasPrivilege";

const ToolsPayoutSubmitted1 = ({ toggleRightBar, type1 }) => {
  const { SECTION_KEY, PAYOUT_ROUTING_EDIT } = ToolsActionRegistry;
  const hasPayoutRoutingEdit = useHasPrivilege(
    SECTION_KEY,
    PAYOUT_ROUTING_EDIT
  );
  // State for the main DataGrid applications
  const [applications, setApplications] = useState([]);
  const [routingType, setRoutingType] = useState("");
  // State for the data displayed in the new MappedVirtualAccounts modal
  const [MappedVirtualAccounts, setMappedVirtualAccounts] = useState([]);

  // State for controlling the visibility of the PayoutRouting modal
  const [isModalRoutingOpen, setIsModalRoutingOpen] = useState(false);
  // State for controlling the visibility of the new MappedVirtualAccounts modal
  const [OpenDetail, setOpenDetail] = useState(false);
  // State to determine if the MappedVirtualAccounts modal is in view-only or edit mode
  const [viewOnly, setViewOnly] = useState(true);
  // State for controlling the visibility of the main "Edit Callback URL" modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  // States related to virtual account data for the main edit modal
  const [companyData, setCompanyData] = useState([]);
  const [companyDataFiltered, setCompanyDataFiltered] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [accessType, setAccessType] = useState("");
  const [routing, setRoutingWith] = useState("");
  const [mid, setmid] = useState("");
  const [companyMid, setCompanyMid] = useState("");
  const [callbackUrl, setCallbackUrl] = useState("");
  const [refresh, setRefresh] = useState(false); // To trigger data re-fetch
  const [anchorEl, setAnchorEl] = useState(null); // Not directly used in the provided code, can be removed if not needed
  const [transType, setTransType] = useState("");

  // State for the main edit callback form
  const [editCallback, setEditCallback] = useState({
    id: "",
    callbackUrl: "",
    transferType: "",
    mappedMid: "",
    mappedWithCompanyName: "",
    usedFor: "",
    mid: "",
    requestRoute: "",
  });

  const [selectedAction, setSelectedAction] = useState(""); // For the main DataGrid action dropdown
  const [transferType, setTransferType] = useState("IMPS"); // Default transfer type

  // Hook for API services
  const { apiCallFnforGet, apiCallFnforPut } = useApiServices();

  // Columns for the main DataGrid
  const columns = [
    { headerName: "Merchant ID", field: "mid", width: 200 },
    { headerName: "Merchant Name", field: "companyName", width: 200 },
    { headerName: "Payout Active For", field: "usedFor", width: 200 },
    { headerName: "Action", field: "action", width: 200 },
  ];

  // Function to handle changes in payout limit input within the MappedVirtualAccounts modal
  // const handlePayoutLimitChange = (id, value) => {
  //   setMappedVirtualAccounts((prevAccounts) =>
  //     prevAccounts.map((account) =>
  //       account.id === id ? { ...account, payoutLimit: value } : account
  //     )
  //   );
  // };

  // const handlePriorityChange = (id, value) => {
  //   if (value < 0) return;
  //   if (value > MappedVirtualAccounts.length) return;
  //   setMappedVirtualAccounts((prevAccounts) =>
  //     prevAccounts.map((account) =>
  //       account.id === id ? { ...account, prority: value } : account
  //     )
  //   );
  // };

  const handlePayoutLimitChange = (id, value) => {
    setMappedVirtualAccounts((prevAccounts) =>
      prevAccounts.map((account) =>
        account.id === id
          ? { ...account, payoutLimit: value, isModified: true } // mark as modified
          : account
      )
    );
  };

  const handlePriorityChange = (id, value) => {
    if (value < 0 || value > MappedVirtualAccounts.length) return;
    setMappedVirtualAccounts((prevAccounts) =>
      prevAccounts.map((account) =>
        account.id === id
          ? { ...account, prority: value, isModified: true } // mark as modified
          : account
      )
    );
  };

  // Function to handle Enable/Disable action for individual mapped accounts in the MappedVirtualAccounts modal
  const handleMappedAccountEnbDsb = async (item, action) => {
    const EnableOrDisable = action === "enable" ? "enable" : "disable";
    swal({
      title: "Alert",
      text: `Are you sure, you want to ${EnableOrDisable} this mapped account?`,
      icon: "warning",
      buttons: "Okay",
      dangerMode: true,
    }).then(async (willProceed) => {
      if (willProceed) {
        try {
          const res = await apiCallFnforPut(
            `${ENABLE_DISABLE_VIRTUAL_ACC}${EnableOrDisable}/${item.id}?id=${item.id}`
          );
          if (res.statusCode === 200) {
            swal({
              title: "Success!",
              text: `Mapped account ${EnableOrDisable} Successfully`,
              icon: "success",
            });
            // Re-fetch details for the current merchant to update the modal's data
            setTimeout(() => {
              handleView({ mid: item.mid }, viewOnly);
            }, 2000);
          } else {
            swal({
              title: "Failed",
              text: `Failed to ${EnableOrDisable}: ${
                res.message || "Unknown error"
              }`,
              icon: "error",
            });
          }
        } catch (error) {
          console.error(`Error ${EnableOrDisable} mapped account:`, error);
          swal({
            title: "Error",
            text: `Failed to ${EnableOrDisable} mapped account.`,
            icon: "error",
          });
        }
      }
    });
  };

  const handleUpdateMappedVirtualAccounts1 = async () => {
    let allUpdatesSuccessful = true;
    for (const account of MappedVirtualAccounts) {
      try {
        const payload = MappedVirtualAccounts?.map((account) => {
          return {
            domain: account?.domain ?? "",
            flag: account?.flag,
            id: Number(account?.id) ?? 0,
            masterId: Number(account?.masterId) ?? 0,
            mid: account?.mid ?? "",
            processor: account?.processor ?? "",
            prority: Number(account?.prority) ?? 0,
            routingType: account?.routingType ?? "",
            sidLimit: Number(account?.payoutLimit) ?? 0,
            status: account?.status ?? "",
          };
        });

        const response = await apiCallFnforPut(UPDATE_MERCHANT_ALl, payload);
        if (response.statusCode !== 200) {
          allUpdatesSuccessful = false;
          console.error(
            `Failed to update account ${account.id}:`,
            response.message
          );
          swal({
            title: "Failed",
            text: `Failed to update payout limit for ${account.companyName}: ${response.message}`,
            icon: "error",
          });
          break; // Stop on first error, or continue and report all errors
        }
      } catch (error) {
        allUpdatesSuccessful = false;
        console.error(`Error updating account ${account.id}:`, error);
        swal({
          title: "Error",
          text: `Error updating payout limit for ${account.companyName}.`,
          icon: "error",
        });
        break;
      }
    }

    if (allUpdatesSuccessful) {
      swal({
        title: "Success!",
        text: "Payout limits updated successfully.",
        icon: "success",
      });
      setOpenDetail(false); // Close the modal after successful update
      setRefresh(!refresh); // Refresh the main grid data
    } else {
      swal({
        title: "Partial Success/Failure",
        text: "Some payout limits could not be updated. Check console for details.",
        icon: "warning",
      });
    }
  };

  const handleUpdateMappedVirtualAccounts = async () => {
    const modifiedAccounts = MappedVirtualAccounts.filter(
      (acc) => acc.isModified
    );

    console.log(modifiedAccounts, "modifiedAccounts");
    if (modifiedAccounts.length === 0) {
      swal({
        title: "No Changes",
        text: "No payout limits or priorities were modified.",
        icon: "info",
      });
      return;
    }

    try {
      const payload = modifiedAccounts.map((account) => ({
        domain: account?.domain ?? "",
        flag: account?.flag,
        id: Number(account?.id) ?? 0,
        masterId: Number(account?.masterId) ?? 0,
        mid: account?.mid ?? "",
        processor: account?.processor ?? "",
        prority: Number(account?.prority) ?? 0,
        routingType: account?.routingType ?? "",
        sidLimit: Number(account?.payoutLimit) ?? 0,
        status: account?.status ?? "",
      }));
      console.log(payload, "payload");
      const response = await apiCallFnforPut(UPDATE_MERCHANT_ALl, payload);

      if (response.statusCode === 200) {
        swal({
          title: "Success!",
          text: "Updated successfully.",
          icon: "success",
        });
        setOpenDetail(false);
        setRefresh(!refresh);
      } else {
        swal({
          title: "Failed",
          text: response.message || "Unknown error",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error updating accounts:", error);
      swal({
        title: "Error",
        text: "Something went wrong while updating.",
        icon: "error",
      });
    }
  };

  // Columns for the MappedVirtualAccounts modal's DataGrid
  const columns1 = [
    { headerName: "Merchant ID", field: "mid", width: 150 },
    { headerName: "Merchant Name", field: "companyName", width: 180 },
    { headerName: "Mapped With", field: "masterCompanyName", width: 180 },
    {
      headerName: "Payout Limit",
      field: "payoutLimit",
      width: 150,
      renderCell: (params) =>
        viewOnly ? (
          // Display as text if in view-only mode
          params.value
        ) : (
          // Display as input field if in edit mode

          <input
            type="number"
            value={params.value}
            onChange={(e) =>
              handlePayoutLimitChange(params.row.id, e.target.value)
            }
            className="form-control"
            style={{
              width: "100%",
              padding: "5px",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
          />
        ),
    },
    {
      headerName: "Priority",
      field: "prority", // You might want to fix the typo if it's meant to be "priority"
      width: 150,
      renderCell: (params) => {
        const isRR = params.row.routingType === "RR";

        if (isRR) {
          return "NA";
        }

        if (viewOnly) {
          return params.value;
        }

        return (
          <input
            type="number"
            value={params.value}
            onChange={(e) =>
              handlePriorityChange(params.row.id, e.target.value)
            }
            className="form-control"
            style={{
              width: "100%",
              padding: "5px",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
          />
        );
      },
    },

    { headerName: "Payout Active For", field: "usedFor", width: 150 },
    { headerName: "Route With", field: "requestRoute", width: 150 },
    {
      headerName: "Status",
      field: "status",
      width: 100,
      renderCell: (params) => (
        <span className={`badge ${params.value ? "bg-success" : "bg-danger"}`}>
          {!params.value ? "inactive" : "Active"}
        </span>
      ),
    },
    {
      headerName: "Action",
      field: "action",
      width: 150,

      renderCell: ({ row }) => (
        <Button
          variant="contained"
          size="small"
          onClick={() =>
            handleMappedAccountEnbDsb(row, row.status ? "disable" : "enable")
          }
          className={`btn btn-sm ${
            row.status ? "btn-danger" : " btn btn-success"
          }`}
        >
          {row.status ? "Disable" : "Enable"}
        </Button>
      ),
    },
  ];

  const getVirtualAccountData = async (type) => {
    await apiCallFnforGet(GET_VIRTUAL_ACCOUNT_DATA + type)
      .then((response) => {
        if (response.statusCode === 200) {
          // alert("Virtual Account Data:", response.data[0].routingType);
          setCompanyData(response.data);
        } else {
          setCompanyData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching virtual account data:", error);
      });
  };

  // Filters company data based on routing selection
  useEffect(() => {
    if (routing === "") {
      // setRoutingType(companyData[0]?.routingType || "");
      setCompanyDataFiltered(companyData);
    } else {
      // setRoutingType(companyData[0]?.routingType || "");
      setCompanyDataFiltered(
        companyData?.filter(
          (item) => item?.masterAliusId?.split("_")[0].toUpperCase() === routing
        )
      );
    }
  }, [routing, companyData]); // Added companyData to dependency array

  // Opens the main "Edit Callback URL" modal
  const openDetails = (
    id,
    callbackUrl,
    transferType,
    mappedMid,
    mappedWithCompanyName,
    usedFor,
    mid,
    requestRoute
  ) => {
    setEditCallback({
      id,
      callbackUrl,
      transferType,
      mappedMid,
      mappedWithCompanyName,
      usedFor,
      mid,
      requestRoute,
    });

    setIsModalOpen(true);
    getVirtualAccountData(transferType);
    setSelectedCompany(mappedWithCompanyName); // Set selected company for the dropdown
    setCompanyMid(mappedMid);
    setmid(mid);
    setAccessType(usedFor);
    setCallbackUrl(callbackUrl); // Ensure callbackUrl is set for the input
    setRoutingWith(requestRoute);
    setTransType(transferType); // Set transfer type for the checkboxes
  };

  // Closes the main "Edit Callback URL" modal and resets states
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditCallback({
      id: "",
      callbackUrl: "",
      transferType: "",
      mappedMid: "",
      mid: "",
    });
    setAccessType("");
    setRoutingWith("");
    setRefresh(!refresh); // Trigger refresh of main grid
  };

  // Handles Enable/Disable action for main merchant entries
  const EnbDsb = async (id, action) => {
    const EnableOrDisable = action === "enable" ? "enable" : "disable";
    swal({
      title: "Alert",
      text: `Are you sure, you want to ${EnableOrDisable}`,
      icon: "warning",
      buttons: "Okay",
      dangerMode: true,
    }).then((willDisable) => {
      if (willDisable) {
        // No need for FormData, directly send ID in URL for PUT
        apiCallFnforPut(
          `${ENABLE_DISABLE_PAYOUT_ROUTING}${EnableOrDisable}/${id}`
        )
          .then((res) => {
            if (res.statusCode === 200) {
              swal({
                title: "Success!",
                text: `Payout Routing ${EnableOrDisable} Successfully`,
                icon: "success",
              });
              setTimeout(() => {
                FetchData();
              }, 2000); // Delay refresh to allow swal to be seen
            } else {
              swal({
                title: "Failed",
                text: `Failed to ${EnableOrDisable}: ${
                  res.message || "Unknown error"
                }`,
                icon: "error",
              });
            }
          })
          .catch((error) => {
            console.error("Error enabling/disabling:", error);
            swal({
              title: "Error",
              text: `Failed to ${EnableOrDisable} due to an error.`,
              icon: "error",
            });
          });
      }
    });
  };

  // Handles changes in the main edit callback form inputs
  const handelDataChange = (e) => {
    const { name, value } = e.target;
    setEditCallback({ ...editCallback, [name]: value });
  };

  // Handles submission of the main edit callback form
  const handleUpdateSubmit = async (e) => {
    e.preventDefault();

    if (
      editCallback.usedFor?.toUpperCase() === "API" &&
      editCallback.callbackUrl === ""
    ) {
      swal({
        title: "Alert!",
        text: "Please Enter Callback URL",
        icon: "error",
      });
      return;
    }

    const payload = {
      callbackUrl: editCallback.callbackUrl,
      id: editCallback.id,
      mappedMid: companyMid,
      mid: mid,
      transferType: transType,
      usedFor: accessType,
      requestRoute: routing,
    };

    await apiCallFnforPut(UPDATE_MERCHANT, payload)
      .then((response) => {
        if (response.statusCode === 200) {
          swal({
            title: "Success!",
            text: "Details Updated Successfully.",
            icon: "success",
          });
          handleCloseModal(); // Close main edit modal
        } else {
          swal({
            title: "Alert!",
            text: response.message,
            icon: "error",
          });
        }
      })
      .catch((error) => {
        console.error("Error updating merchant:", error);
        swal({
          title: "Error",
          text: "Failed to update details.",
          icon: "error",
        });
      });
  };

  // Closes the PayoutRouting modal
  const handleCloseModalRouting = () => {
    setIsModalRoutingOpen(false);
  };

  // Fetches and displays previous mapped details for a merchant in a new modal
  const handleView = async (item, type) => {
    try {
      const apiResponse = await apiCallFnforGet(
        GET_PREV_MAPPED_DETAILS_PAYOUT + item.mid
      );
      if (apiResponse.statusCode === 200) {
        // Assign unique IDs to the mapped virtual accounts for DataGrid
        const mappedDataWithIds = apiResponse.data.map((dataItem, index) => ({
          ...dataItem,
          id: dataItem.id || `mapped-${index}`, // Ensure unique ID for DataGrid
        }));
        setRoutingType(mappedDataWithIds[0]?.routingType || "");
        setMappedVirtualAccounts(mappedDataWithIds);
        setOpenDetail(true); // Open the new modal
        setViewOnly(type); // Set viewOnly based on the 'type' argument (true for view, false for edit)
      } else {
        swal({
          title: "No Data",
          text: "No previous mapped details found for this merchant.",
          icon: "info",
        });
      }
    } catch (error) {
      console.error("Error fetching previous mapped details:", error);
      swal({
        title: "Error",
        text: "Failed to fetch previous mapped details.",
        icon: "error",
      });
    }
  };

  // Handles actions for the main DataGrid (edit, enable, disable, view)
  const handleAction = (item, action) => {
    switch (action) {
      case "edit":
        // This 'edit' opens the main edit callback URL modal
        openDetails(
          item.id,
          item.callbackUrl,
          item.transferType,
          item.mappedMid,
          item.mappedWithCompanyName,
          item.usedFor,
          item.mid,
          item.requestRoute
        );
        break;
      case "enable":
        if (!item.active) {
          EnbDsb(item.id, "enable");
        }
        break;
      case "disable":
        if (item.active) {
          EnbDsb(item.id, "disable");
        }
        break;
      case "view":
        // This 'view' opens the MappedVirtualAccounts modal in view-only mode
        handleView(item, true); // Pass true for viewOnly
        break;
      default:
        break;
    }
  };

  // Handles menu item clicks for the main DataGrid action dropdown
  const handleMenuItemClick = (action, type, item) => {
    // Set editCallback state for the main edit modal, even if not opening it immediately
    setEditCallback({
      id: item.id,
      callbackUrl: item.callbackUrl,
      transferType: item.transferType,
      mappedMid: item.mappedMid,
      mappedWithCompanyName: item.mappedWithCompanyName,
      usedFor: item.usedFor,
      mid: item.mid,
      requestRoute: item.requestRoute,
    });
    setAccessType(item.usedFor);
    setSelectedAction(action); // Set the selected action for the dropdown
    setAnchorEl(null); // Close the menu (if using Material-UI Menu component)
    setTransType(type); // Set transfer type

    // Differentiate between edit and view for opening the MappedVirtualAccounts modal
    if (action === "edit") {
      handleView(item, false); // Open new modal in editable mode
    } else if (action === "view") {
      handleView(item, true); // Open new modal in view-only mode
    }
  };

  // Fetches all merchant validations for the main DataGrid
  const FetchData = async () => {
    try {
      const apiResponse = await apiCallFnforGet(GET_ALL_PAYOUT_ROUTING_VIEW);
      if (apiResponse.statusCode === 200) {
        const finalRes = apiResponse.data.map((item, i) => ({
          ...item,
          id: item.id || i, // Ensure unique ID for DataGrid
          usedFor: item.usedFor ? item.usedFor.toUpperCase() : "",
          requestRoute: item.requestRoute,
          action: (
            <>
              {hasPayoutRoutingEdit && (
                <button
                  className="btn btn-primary btn-sm me-2"
                  value="edit"
                  onClick={() =>
                    handleMenuItemClick("edit", item.transferType, item)
                  }
                >
                  Edit
                </button>
              )}
              <button
                className="btn btn-primary btn-sm me-2"
                value="view"
                onClick={() =>
                  handleMenuItemClick("view", item.transferType, item)
                }
              >
                View
              </button>
            </>
          ),
        }));
        setApplications(finalRes);
      } else {
        setApplications([]);
      }
    } catch (error) {
      console.error("Error fetching merchant validations:", error);
    }
  };

  // Effect to fetch initial data and re-fetch on 'refresh' state change
  useEffect(() => {
    FetchData();
  }, [refresh]);

  const handelRoutingChange = (e) => {
    if (viewOnly) return;
    setRoutingType(e.target.value);
    setMappedVirtualAccounts((prevAccounts) =>
      prevAccounts.map((account) => ({
        ...account,
        routingType: e.target.value, // Update routing type for each account
      }))
    );
  };

  return (
    <>
      <div className="container-fluid">
        <div className="d-flex justify-content-between bg-white">
          <div className="d-flex justify-content-start align-items-center ">
            <button
              type="button"
              className="btn-close m-3"
              onClick={toggleRightBar}
            ></button>
            <div className="fs-2 text-dark fw-bold">Payout-Routing</div>
          </div>
          {hasPayoutRoutingEdit && (
            <div className="d-flex gap-2 justify-content-end mt-3 me-4">
              <CustomTip size="18" placement="top" title=" Payout Routing">
                <div className="" onClick={() => setIsModalRoutingOpen(true)}>
                  <RouteIcon fontSize="large" />
                </div>
              </CustomTip>
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="col-12">
                <div className="card-body">
                  <div className="table-responsive">
                    <DataGrid
                      rows={applications}
                      columns={columns.map((column) => ({
                        ...column,
                        // Render action column with its custom component, otherwise render value directly
                        renderCell: (params) =>
                          column.field === "action"
                            ? params.value
                            : params.value,
                      }))}
                      slots={{
                        toolbar: GridToolbar,
                      }}
                      slotProps={{
                        toolbar: {
                          showQuickFilter: true,
                        },
                      }}
                      getRowId={(row) => row.id} // Essential for DataGrid to identify rows uniquely
                      pageSizeOptions={[5, 10, 25, 50, 100]}
                      initialState={{
                        pagination: {
                          paginationModel: { pageSize: 10, page: 0 },
                        },
                      }}
                      autoHeight
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Payout Routing (from PayoutRouting component) */}
      <PayoutRouting
        show={isModalRoutingOpen}
        onHide={handleCloseModalRouting}
        setRefresh={setRefresh}
        refresh={refresh}
        FetchData={FetchData}
      />

      {/* New Modal for Mapped Virtual Accounts (View/Edit) */}
      <Modal
        show={OpenDetail}
        onHide={() => setOpenDetail(false)}
        backdrop="static"
        keyboard={false}
        size="xl" // Increased size for better DataGrid display
      >
        <Modal.Header closeButton>
          <Modal.Title className="fs-4 fw-bold">
            {viewOnly
              ? "View Mapped Virtual Accounts"
              : "Edit Mapped Virtual Accounts"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="merchant-report-view">
            <div className="report-table-view">
              <div className="col-sm-12 col-md-6 mt-2">
                <label htmlFor="email" className="fs-4 text-dark">
                  Routing Pattern
                </label>
                <select
                  id=""
                  className="form-control"
                  onChange={handelRoutingChange}
                  value={routingType}
                  name="routingPattern"
                >
                  <option value="">Select a Pattern</option>
                  <option value="RR" selected={routingType === "RR"}>
                    Round Robin
                  </option>
                  <option value="SQ" selected={routingType === "SQ"}>
                    Sequential
                  </option>
                </select>
              </div>
              <div className="containerflag ">
                <div className="row mt-4 ">
                  <DataGrid
                    rows={MappedVirtualAccounts}
                    columns={columns1} // Use the modified columns1 directly
                    slots={{
                      toolbar: GridToolbar,
                    }}
                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                      },
                    }}
                    getRowId={(row) => row.id} // Ensure DataGrid can find a unique ID for each row
                    pageSizeOptions={[5, 10, 25, 50, 100]} // Added page size options
                    initialState={{
                      pagination: {
                        paginationModel: { pageSize: 10, page: 0 },
                      },
                    }}
                    autoHeight // Adjusts height automatically based on content
                  />
                </div>
                {!viewOnly && (
                  <div className="d-flex justify-content-end mt-4">
                    <button
                      className="badge badge-rounded badge-primary mx-2 px-3 py-3"
                      onClick={handleUpdateMappedVirtualAccounts}
                    >
                      Update Payout Limits
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ToolsPayoutSubmitted1;
